/**
 * `modules/caseArchiveFilter.js`
 *  - /case/ アーカイブの複合絞り込みボタンを JS 遷移に変換
 *
 * 役割:
 *  - <button data-href="..."> クリック時に location.href = data-href
 *  - 複合クエリ URL (?property_type=a&floor=b …) を <a href> として
 *    HTML に残さないための対応。SEO クロールバジェット節約が目的。
 *
 * 実装方針:
 *  - event delegation で document 直下に 1 listener
 *  - Barba SPA 遷移後の新規 DOM にも同じ listener が効くので再バインド不要
 */

export const initCaseArchiveFilter = () => {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button.column_archive_tag_item_link[data-href]');
    if (!btn) return;
    e.preventDefault();
    const href = btn.dataset.href;
    if (href) {
      window.location.href = href;
    }
  });
};
